import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import MainContainer from './containers/main';
import Return from './containers/return';
import DirectDebitStatus from './containers/directdebit-status';
import CardContainer from './containers/card';

//TODO asiggn a new url for debitStatus
if (window.debitStatus && window.debitStatus !== '') {
    
    const createdDate = moment(window.debitStatus, 'D-M-YYYY');

    ReactDOM.render(<DirectDebitStatus createdDate={createdDate} country={window.country}/>, document.getElementById('root'));
} else {
    
     const Main = () => <MainContainer country={window.country} />;
     const ReturnPage = () => <Return status={Number(window.status)} />;
     const Card = () => <CardContainer country={window.country} />;

    const App = () => (
        <Router>
            <Switch>
                <Route exact path="/ar" component={Main} />
                <Route exact path="/co" component={Main} />
                <Route exact path="/cl" component={Main} />
                <Route exact path="/ma" component={Main} />
                <Route exact path="/sd89fsdofjwe8e" component={Main} />
                <Route exact path="/ljg9ityr08tfd9" component={Main} />
                <Route exact path="/hdf739w5723oij" component={Main} />
                <Route exact path="/83d945tn3o85gf" component={Main} />
                <Route exact path="/v2/ar" component={Main} />
                <Route exact path="/v2/cl" component={Main} />
                <Route exact path="/return" component={ReturnPage} />
                <Route exact path="/cards/cl" component={Card} />
                <Route exact path="/cards/co" component={Card} />
            </Switch>
        </Router>
    );

    ReactDOM.render(<App />, document.getElementById('root'));
}
